import { computed } from 'vue';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue';


export default {
  __name: 'Select',
  props: {
    options: {
        type: [Array, null],
    },
    selected: {
        type: [String, null],
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const selectedName = computed(() => {
    if (!props.selected) return null;
    const option = props.options.find((option) => option.id === props.selected);
    return option ? option.title : null;
});

const __returned__ = { props, selectedName, computed, get Listbox() { return Listbox }, get ListboxButton() { return ListboxButton }, get ListboxOptions() { return ListboxOptions }, get ListboxOption() { return ListboxOption } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}